import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import TextField from "@material-ui/core/TextField";
import { isTextfield } from "../utils/fieldTypes";

@inject("store")
@observer
class FieldSet extends Component {
  render() {
    const {
      form,
      form: { name: formName },
      fields,
      inputProps,
      store: {
        ui: { formSubmitting, initialDisabled }
      }
    } = this.props;
    return (
      <fieldset>
        {fields &&
          fields
            .filter(field => field.type !== "button")
            .map((input, index) => {
              const { type, name: fieldName, extra } = input;
              const field = form.$(fieldName);
              const { error } = field;
              return (
                <Fragment key={`${formName}${fieldName}`}>
                  {isTextfield(type) && (
                    <TextField
                      {...field.bind()}
                      disabled={formSubmitting || initialDisabled}
                      error={!!error}
                      fullWidth
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        ...extra?.inputProps,
                        ...inputProps
                      }}
                      variant="outlined"
                      helperText={`${error ? error : ""} ${
                        extra?.hint ? extra.hint : ""
                      }`}
                    />
                  )}
                </Fragment>
              );
            })}
      </fieldset>
    );
  }
}

export default FieldSet;
